import {
  Box,
  Button,
  Columns,
  Container,
  Heading,
} from '@spaceship-fspl/components';
import { ExternalRoutes } from '@spaceship-fspl/helpers';
import { linearGradient, match } from '@spaceship-fspl/styles';
import { TrackingCategory } from '@spaceship-fspl/tracking';
import { PanelSection } from 'components';
import React, { HTMLAttributeAnchorTarget } from 'react';
import styled from 'styled-components';

export interface SimpleSignupPanelProps {
  title?: string | null;
  signupText?: string | null;
  signupUrl?: string | null;
  signupUrlTarget?: HTMLAttributeAnchorTarget;
}

export const SimpleSignupPanel: React.FC<SimpleSignupPanelProps> = ({
  title,
  signupText,
  signupUrl,
  signupUrlTarget,
}) => {
  if (!signupText) {
    return null;
  }

  return (
    <TrackingCategory category="Simple Sign Up Panel">
      <StyledPanelSection>
        <Container>
          <Columns
            alignX="center"
            alignY="center"
            spaceX={{ lg: 'md' }}
            spaceY={{ xs: 'sm', lg: 'none' }}
          >
            <Columns.Column width={{ xs: 1, lg: 'min' }}>
              <Heading
                component="h3"
                variant={3}
                color="neutral.000"
                align="center"
              >
                {title}
              </Heading>
            </Columns.Column>

            <Columns.Column width={{ xs: 1, lg: 'min' }}>
              <Box display="flex" justifyContent="center">
                <Button
                  href={signupUrl ?? ExternalRoutes.SUPER_SIGNUP}
                  target={
                    signupUrl && signupUrlTarget ? signupUrlTarget : undefined
                  }
                  size="lg"
                  variant="tertiary"
                >
                  {signupText}
                </Button>
              </Box>
            </Columns.Column>
          </Columns>
        </Container>
      </StyledPanelSection>
    </TrackingCategory>
  );
};

const StyledPanelSection = styled(PanelSection).attrs({
  paddingTop: { xs: 'xl', lg: 'sm' },
  paddingBottom: { xs: 'xl', lg: 'sm' },
})`
  background: ${linearGradient({
    colorStops: [
      ['indigo.100', '0%'],
      ['indigo.070', '113.19%'],
    ],
    angle: '31deg',
  })};

  ${match('lg')`
  background: ${linearGradient({
    colorStops: [
      ['indigo.100', '-35.36%'],
      ['indigo.070', '104.73%'],
    ],
    angle: '26deg',
  })};
  `}
`;
